import {
    FetchOrgOverviewV2SuccessAction,
    FETCH_ORG_OVERVIEW_V2_SUCCESS,
    OrgOverviewV2Response,
} from './../actions/orgOverview';
import { OrgOverviewV2 } from '../types';
import { LogoutSuccessAction, LOGOUT_SUCCESS } from '../actions/login';
import { combineReducers } from 'redux';
import { ClearStateAction, CLEAR_STATE } from '../actions/state';

type StatisticsActionTypes = LogoutSuccessAction | FetchOrgOverviewV2SuccessAction | ClearStateAction;

function updateStatisticsById(state: StatisticsById, payload: OrgOverviewV2Response) {
    return {
        ...state,
        [payload.id]: {
            statistics: payload.statistics,
            averageApprovalItemDurations: payload.averageApprovalItemDurations,
        },
    };
}

type StatisticsById = Record<string, OrgOverviewV2>;

function statisticsById(state: StatisticsById = {}, action: StatisticsActionTypes): StatisticsById {
    switch (action.type) {
        case FETCH_ORG_OVERVIEW_V2_SUCCESS:
            return updateStatisticsById(state, action.payload);
        case LOGOUT_SUCCESS:
        case CLEAR_STATE:
            return {};
        default:
            return state;
    }
}

const statisticsReducer = combineReducers({
    byId: statisticsById,
});

export default statisticsReducer;
